//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CFooter from "@/common/Footer"
export default{
  data(){
    return{
      showA: '-1',
      productList:[
        {
          title: '独享虚拟主机',
          subTil: ' 基于云计算的虚拟主机服务',
          content: '独立IP、不限流量、语言环境：ASP、PHP、ASP.NET 提供4款经典组合产品供用户选择，详细PC版查看',
        },
        {
          title: '共享虚拟主机',
          subTil: '极速稳定高弹性的计算服务',
          content: '共享IP、套餐流量、语言环境：ASP、PHP 提供4款经典组合产品供用户选择，详细PC版查看',
        },
        {
          title: '独享虚拟主机优势',
          subTil: '提供五星级的域名注册服务',
          content: '（1）网站违规导致IP被封，不会受到影响。 （2）当同一台服务器上其他虚机客户遭受DDOS攻击时，不 会受到牵连 （3）独享IP虚拟主机采用独立带宽，流量不限制，您再也 无需担心流量不够用了 （4）可以通过泛解析绑定主域名下面的无数子域名 （5）在没有绑定域名的情况下，可以使用IP地址直接访问 （6）如果一个IP只对应一个网站，则搜索引擎会评定该网 站质量更高，从而提高收录级别，搜索引擎更容易抓取到该 网站的页面，有利于网站的宣传和网络营销',
        },
      ]
    }
  },
  components: {
    CFooter
  },
  methods:{
    listDown(d) {
      if(this.showA == d) {
        this.showA = '-1'
      } else {
        this.showA = d
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/product/vhost.vue